// Day and month names from the app's translations (dateNames.* in the locale files).
// Browsers often ship without Icelandic Intl data, so toLocaleDateString('is-IS') comes out
// in English; these follow the language the app is set to. `t` is the component's $t.

export const weekdayName = (t, d) => t(`dateNames.weekdays[${d.getDay()}]`);
export const weekdayShort = (t, d) => t(`dateNames.weekdaysShort[${d.getDay()}]`);
export const monthName = (t, d) => t(`dateNames.months[${d.getMonth()}]`);
export const monthShort = (t, d) => t(`dateNames.monthsShort[${d.getMonth()}]`);
